module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "file_023"
    }
  }, [_vm._v("No way. Grumman had already inspected the navy’s frontline Boeing F4B fighters on the sly. He’d had the thought himself and perused the little biplanes on the flight line. The retractable gear would no doubt make the little machines faster, but there was no practical way to shoehorn the gear into a plane that ")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("had not specifically been made for it. The F4B would have to be built again from nearly the ground up.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("That was the crux of the matter right there. If a fighter plane was going to be built around Grumman’s revolutionary gear, it damn well was going to be "), _c('em', [_vm._v("his")]), _vm._v(" plane, not Boeing’s.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In essence, the navy said to him, “Well, let’s see the plane then.” It was a big chance for the little company—a test that could make or break Grumman’s relationship with the navy for years to come.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Navy types may have called the design the high-performance two-seater fighter (HPTSF), but the excited workers at Grumman simply called it “The Plane.” The proposal for the first in an epical series of Grumman carrier fighters was accepted by the U.S. Navy on March 29, 1930.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Hellcat’s eldest brother had very little in common with the future predator of the Pacific. The HPTSF was a biplane, with fabric-covered wings and a strangely tubby body, bulged at the bottom to accommodate Grumman’s fold-down main wheels. A hand crank required thirty-five arm-busting turns to drag the wheels up into a stowed position after takeoff.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The plane would hold two crewmen, a pilot and rear gunner, with the latter manning a .30-caliber flexible gun pointing aft. The machine would be equipped with two more .30-calibers synchronized to fire forward, through the propeller. The plane would fly with a Wright R-1820 Cyclone radial engine that generated about 575 horsepower (in the earliest models).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After a year of mockups, planning, and wind tunnel testing, the navy committed to the purchase of a fully functional prototype fighter on March 28, 1931. It would be known by the navy’s Bureau of Aeronautics as the XFF-1.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d2d9a0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_023.vue
// module id = 120
// module chunks = 0